import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import DetailOfRent from "./DetailOfRent";
import rahel from "../../../img/rahel1.jpg";
import "./rent.css";
import _ from "lodash";

const TableScrolePrint = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { R_dataTable, R_joripara, R_kartonakan, R_koywaznkarton } =
            value;
          let arr = [];
          for (let i = R_dataTable.length; i > 0; i--) {
            const el = R_dataTable[i - 1];
            if (el) {
              arr = [...arr, el];
            }
          }
          const dataRentPrint = arr.map((user, i) => {
            return (
              <tr
                key={i}
                className="f4"
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black"
                }}
              >
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {R_joripara == "دۆلار" ? (
                    <NumberFormat
                      value={
                        Number.isInteger(Number(user.kodolar))
                          ? Number(user.kodolar)
                          : Number(user.kodolar).toFixed(2)
                      }
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  ) : (
                    <NumberFormat
                      value={
                        Number.isInteger(Number(user.kodinar))
                          ? Number(user.kodinar)
                          : Number(user.kodinar).toFixed(2)
                      }
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  )}
                </td>
                {/* <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {user.reja}
                </td> */}
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {
                    <NumberFormat
                      value={user.nrx}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  }
                </td>
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {user.darzan}
                </td>
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {(() => {
                    const num = Number(user.carton);
                    if (Number.isInteger(num)) {
                      return num;
                    }

                    const decimalPlaces = num.toString().split('.')[1]?.length || 0;

                    if (decimalPlaces <= 2) {
                      return num.toFixed(2);
                    } else {
                      return num.toFixed(3);
                    }
                  })()}
                </td>
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {user.nawisht}
                </td>
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {user.raqam}
                </td>
              </tr>
            );
          });

          return (
            <>
              <table
                id="example"
                className="tc black-90 py-3 f2-l fk"
                media="print"
              >
                <thead>
                  <tr
                    className="text-dark f4"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black"
                    }}
                  >
                    <th colSpan="8 fixed">
                      <img src={rahel} alt="rahel" />
                      <DetailOfRent />
                    </th>
                  </tr>

                  <tr
                    className="text-black-50 f4 fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black"
                    }}
                  >
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      {R_joripara == "دۆلار" ? " کۆی گشتی" : " کۆی گشتی"}
                    </th>
                    {/* <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      ڕێژە
                    </th> */}
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      نرخ د.ن
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      دەرزن
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      کارتۆن
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      ناوی شتەکان
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      ژ.کاڵاکان
                    </th>
                  </tr>
                </thead>
                <tbody
                  media="printe"
                  style={{ borderBottom: "1px solid black" }}
                >
                  {dataRentPrint}
                </tbody>
                <tfoot>
                  <tr className="text-black">
                    {/* <th>2</th> */}
                    <th colSpan="4" className="f4">
                      {" "}
                      {/* تێبینی : گۆڕین و گەڕانەوەی کاڵا نیە{" "} */}
                      "تێبینی : هەڵە بۆ هەردوولا دەگەڕێتەوە"
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black"
                      }}
                      className="f4"
                    >
                      {R_kartonakan}
                    </th>
                    <th colSpan="2" className="f4">
                      {" "}
                      {/* {`${R_koywaznkarton} kg`} : کێشی کاڵاکان */}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default TableScrolePrint;
